import type { MessageKey } from '../../i18n/en';

export const SETTINGS_HOME = '/app/settings';
export const SETTINGS_THEME = '/app/settings/theme';
export const SETTINGS_LANGUAGE = '/app/settings/language';
export const SETTINGS_DEFAULTS = '/app/settings/app-defaults';

export function defaultsCategoryPath(category: string): string {
  return `${SETTINGS_DEFAULTS}/${category}`;
}

const CATEGORY_SHELL: Record<string, { title: MessageKey; description: MessageKey }> = {
  map: { title: 'defaults.map.title', description: 'defaults.map.desc' },
  stationary: { title: 'defaults.stationary.title', description: 'defaults.stationary.desc' },
  playlist: { title: 'defaults.playlist.title', description: 'defaults.playlist.desc' },
  itinerary: { title: 'defaults.itinerary.title', description: 'defaults.itinerary.desc' },
  joystick: { title: 'defaults.joystick.title', description: 'defaults.joystick.desc' },
  player: { title: 'defaults.player.title', description: 'defaults.player.desc' },
};

export function settingsShellCopy(
  pathname: string
): { title: MessageKey; description: MessageKey } | null {
  if (pathname === SETTINGS_THEME) {
    return { title: 'settings.theme.shellTitle', description: 'settings.theme.shellDesc' };
  }
  if (pathname === SETTINGS_LANGUAGE) {
    return { title: 'settings.language.shellTitle', description: 'settings.language.shellDesc' };
  }
  if (pathname === SETTINGS_DEFAULTS) {
    return { title: 'settings.defaults.shellTitle', description: 'settings.defaults.shellDesc' };
  }
  const match = pathname.match(/^\/app\/settings\/app-defaults\/([^/]+)$/);
  if (!match) return null;
  return CATEGORY_SHELL[match[1]] ?? null;
}
